export default __webpack_public_path__ + "static/media/CloseGraphSideBar.f7a4700e.svg";